export default "__VITE_ASSET__DhBVoqFD__"